import { useEffect } from "react";
import { useParams, useRouter, useNavigate, createFileRoute } from "@tanstack/react-router";

function ClassDetailPage() {
  const params = useParams({ strict: false });
  const router = useRouter();
  const navigate = useNavigate();
  const classId = params.id as string;

  useEffect(() => {
    // 반 상세 페이지는 학생 관리 페이지로 리다이렉트
    navigate({ to: `/classes/${classId}/students`, replace: true });
  }, [classId, router]);

  return null;
}

export const Route = createFileRoute("/_content/classes/$id/")({
  component: ClassDetailPage,
});
